export enum ESystemMessages {
  NETWORK_ERROR = 'system.messages.network_error',
  PAGE_NOT_FOUND = 'system.messages.page_not_found'
}
